import React from 'react'
import SearchProductList from '../app/Product-List/SearchProductList'

const SearchPage = () => {
  return (
    <div>
    <SearchProductList/>
    </div>
  )
}

export default SearchPage
